import React from '../services/React';
import UI from '../services/UI';
import TimeRanges from './TimeRanges';
import TextInput from './TextInput';
import WixDatePicker from '../../commons/components/WixDatePicker';

function SpecialOpeningHours(
  {
    onStartChange,
    onEndChange,
    onNoteChange,
    onTimerangesChange,
    timeranges,
    title,
    start,
    end,
    note
  }
) {
  return (
    <div>
      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Text" />
      <hr className="divider-long" />

      <TextInput
        value={note}
        title="Note"
        placeholder="e.g., We are on vacation"
        infoText="Define a special event which happens once in between a specific date range with optional time slots. Shows up in the business hours table."
        maxLength={50}
        invalidMessage="Limit reached"
        validator={val => (val || '').length < 50}
        onChange={onNoteChange}
      />

      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Date" />
      <hr className="divider-long" />

      <WixDatePicker
        label="Start Date"
        selected={start}
        onChange={onStartChange}
      />

      <hr className="divider-short" />

      <WixDatePicker label="End Date" selected={end} onChange={onEndChange} />

      <TimeRanges onChange={onTimerangesChange} timeranges={timeranges} />
    </div>
  );
}

export default SpecialOpeningHours;



// WEBPACK FOOTER //
// ./src/commons/components/SpecialOpeningHours.jsx